<template>
	<div class="text-center">
		<v-container>
			<div :class="['text-h6', 'pa-2']">
				{{ $t('titles.externalCertificate') }}
			</div>
			<v-row>
				<v-col cols="12">
					<Dropdown
						v-model="externalCertificate.candidate_id"
						:ajax="true"
						:data="'candidates'"
						:errorBorder="!externalCertificateValidation.candidate_id"
						:label="'* ' + $t('fields.candidate')"
					></Dropdown>
				</v-col>
				<v-col cols="12">
					<Dropdown
						v-model="externalCertificate.course_id"
						:ajax="true"
						:data="'courses'"
						:errorBorder="!externalCertificateValidation.course_id"
						:label="'* ' + $t('fields.course')"
					></Dropdown>
				</v-col>
				<v-col cols="12">
					<InputField
						v-model="externalCertificate.certificate_number"
						:errorBorder="!externalCertificateValidation.certificate_number"
						:label="'* ' + $t('fields.certificateNumber')"
					></InputField>
				</v-col>
				<v-col cols="12">
					<DatePicker
						v-model="externalCertificate.issue_date"
						:errorBorder="!externalCertificateValidation.issue_date"
						:date-label="'* ' + $t('fields.issueDate')"
					></DatePicker>
				</v-col>
				<v-col cols="12">
					<DatePicker
						v-model="externalCertificate.expiration_date"
						:disabled="externalCertificate.unlimited_validity"
						:errorBorder="!externalCertificateValidation.expiration_date"
						:date-label="$t('fields.expirationDate')"
					></DatePicker>
				</v-col>
				<v-col cols="12">
					<CheckBox
						v-model="externalCertificate.unlimited_validity"
						:label="$t('fields.unlimitedValidity')"
					></CheckBox>
				</v-col>
				<v-col cols="12">
					<Upload :label="'* ' + $t('fields.file')" v-model="externalCertificate.certificate_file"></Upload>
				</v-col>
			</v-row>
		</v-container>
		<v-spacer></v-spacer>
		<v-row>
			<v-col cols="12">
				<v-btn class="ma-2" color="primary" variant="text" @click="saveClick">
					{{ $t('buttons.save') }}
				</v-btn>
				<v-btn class="ma-2" color="basicButton" variant="text" @click="cancelClick">
					{{ $t('buttons.cancel') }}
				</v-btn>
			</v-col>
		</v-row>
	</div>
</template>

<script>
import InputField from '../../trinkets/InputField';
import CheckBox from '../../trinkets/CheckBox';
import Dropdown from '../../trinkets/Dropdown';
import DatePicker from '../../trinkets/DatePicker';
import Upload from '../../trinkets/Upload';
import IssuedCertificate from '../../../models/IssuedCertificate';

export default {
	name: 'ExternalCertificate',
	components: { Upload, DatePicker, InputField, Dropdown, CheckBox },
	props: {
		certificateId: [Number, String],
		inEditMode: Boolean,
	},
	emits: ['close', 'reloadIssuedCertificates'],
	data() {
		return {
			externalCertificate: new IssuedCertificate({ id: 0 }),
			externalCertificateValidation: new IssuedCertificate({}, true),
		};
	},
	watch: {
		'externalCertificate.unlimited_validity': function (newVal) {
			if (newVal) {
				this.externalCertificate.expiration_date = null;
			}
		},
		'inEditMode'(newVal) {
			if (newVal) {
				this.getFile();
			}
		},
	},
	methods: {
		cancelClick() {
			this.$emit('close');
		},
		getFile() {
			let vm = this;
			if (this.certificateId) {
				this.$APICall('get', 'issued-certificates/file/' + this.certificateId, {}, (data, success) => {
					if (success) {
						vm.externalCertificate = JSON.parse(JSON.stringify(data));
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				});
			}
		},
		saveClick() {
			let success = true;
			let errorMessages = '';

			if (!this.externalCertificate.candidate_id) {
				success = false;
				this.externalCertificateValidation.candidate_id = false;
			} else {
				this.externalCertificateValidation.candidate_id = true;
			}

			if (!this.externalCertificate.course_id) {
				success = false;
				this.externalCertificateValidation.course_id = false;
			} else {
				this.externalCertificateValidation.course_id = true;
			}

			if (
				this.externalCertificate.certificate_number == null ||
				this.externalCertificate.certificate_number == ''
			) {
				success = false;
				this.externalCertificateValidation.certificate_number = false;
			} else {
				if (this.externalCertificate.certificate_number.length > 20) {
					this.externalCertificateValidation.certificate_number = false;
					errorMessages +=
						this.$t('alerts.lengthError')
							.replace('%field%', this.$t('fields.certificateNumber'))
							.replace('%length%', '20') + '<br />';
				} else {
					this.externalCertificateValidation.certificate_number = true;
				}
			}

			if (!this.externalCertificate.issue_date) {
				success = false;
				this.externalCertificateValidation.issue_date = false;
			} else {
				this.externalCertificateValidation.issue_date = true;
			}

			if (!this.externalCertificate.certificate_file.upload_id) {
				success = false;
				errorMessages += this.$t('alerts.fileMissing') + '<br />';
			}

			if (errorMessages !== '') {
				this.$alert(errorMessages);
				success = false;
			}

			if (success) {
				let vm = this;
				let action = 'post';
				let addition = '';
				if (this.inEditMode) {
					action = 'put';
					addition = '/' + this.certificateId;
				}
				this.$APICall(
					action,
					'issued-certificates/external-certificate' + addition,
					this.externalCertificate,
					(data, success) => {
						if (success) {
							vm.$notify(vm.$t('alerts.basicAdd'));
							vm.$modalBus.$emit('reloadIssuedCertificates');
						} else {
							vm.$alert(vm.$t('alerts.basicError'));
						}
						this.$emit('close');
					}
				);
			}
		},
	},
	mounted() {
		if (this.inEditMode) {
			this.getFile();
		}
	},
};
</script>
